import { env } from "@/lib/env";
import css from "./DebugToolbar.module.scss";

export function DebugToolbar() {
  const branchName = env.BRANCH_NAME ?? "unknown-branch";
  const commitSha = env.COMMIT_SHA != null ? env.COMMIT_SHA.slice(0, 12) : "unknown-sha";

  return (
    <p className={css.debug} hidden={env.RUN_ENV === "production"}>
      <span className={css.branchName}>{branchName}</span> (<span className={css.commitSha}>{commitSha}</span>)
    </p>
  );
}
